import { render, staticRenderFns } from "./schedule-section.vue?vue&type=template&id=13c57263&scoped=true&"
import script from "./schedule-section.vue?vue&type=script&lang=js&"
export * from "./schedule-section.vue?vue&type=script&lang=js&"
import style0 from "./schedule-section.vue?vue&type=style&index=0&id=13c57263&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c57263",
  null
  
)

export default component.exports